import styled from "@emotion/styled"
import { readableColor } from "polished"

import { Row, Col } from "@components/grid"
import { rhythm, scale } from "@utils/typography"

const Number = styled(Col)`
  align-items: center;
  background-color: ${props => props.background || props.theme.color};
  color: ${props => readableColor(props.background || props.theme.color)};
  display: flex;
  ${scale(1.5)};
  font-weight: 600;
  justify-content: center;
  text-align: center;
  width: 16%;
`

const NumberRow = styled(Row)`
  align-items: center;
  margin: ${rhythm(1.2)} 0;
`

const NumberText = styled(Col)`
  ${scale(1 / 3)};
  width: 84%;
`

export { Number, NumberRow, NumberText }
